import styled, { keyframes } from 'styled-components';
export const SpinWrapper = styled.div.withConfig({
  componentId: "Spin__sc-174943q-0"
})(["display:inline-flex;justify-content:center;align-items:center;background:transparent;"]);
const SpinnerAnimation = keyframes(["to{transform:rotate(360deg)}"]);
export const SpinSvg = styled.svg.withConfig({
  componentId: "Spin__sc-174943q-1"
})(["animation:", " 0.85s linear infinite;"], SpinnerAnimation);